import { HomeView } from "../views/homeView.jsx";
import {observer} from "mobx-react-lite";
import { readFromFirebase } from "../firebaseModel.js";

const Home = observer(

    function HomeRender(props){

        function setPageHandler(page){
            props.model.setPage(page)
            if(page != 'Quiz') props.model.doSearch()
        }
        function setLoginHandler(id){
            props.model.setUserID(id)
            readFromFirebase(props.model)
        }
        
        return <HomeView  setPageHandler = {setPageHandler}
                          setLoginHandler = {setLoginHandler}
                          userID = {props.model.userID}/>
    
    }

)

export {Home}